﻿<script setup lang="ts">
    import { ref } from 'vue';
    import CodeEdit from '@/shared/codeedit/CodeEdit.vue';
    import ModalBaseFooterLess from '@/shared/components/ModalBaseFooterLess.vue';
    import { CodeEditContextRefCode } from '@/shared/helpers/api.ts';
    import { CodeEditFields } from '@/shared/codeedit/codeEditFields.ts';
    import { CodeTemplateValues } from '@/shared/codeedit/codeTemplate.ts';
    import {
        CodeRefChangedHandlers,
        CodeRefFilterFunctions,
        CodeRefValidators
    } from '@/shared/codeedit/referableCodeHandling.ts';

    type Props = {
        codeId?: string;
        codeSetName?: string;
        title?: string;
        library: string;
        codeTemplateValues?: CodeTemplateValues;
        beforeSaveCode?: (_code: CodeEditFields, _refCodes: Record<string, CodeEditContextRefCode[]>) => Promise<void>;
        fieldsToDisable?: string[];
        referableCodesFilters?: CodeRefFilterFunctions<CodeEditFields>;
        referableCodesValidators?: CodeRefValidators<CodeEditFields>;
        refCodeChangedHandlers?: CodeRefChangedHandlers<CodeEditFields>;
    };

    const emit = defineEmits<{
        onRefresh: [];
        onCancel: [];
    }>();

    const isLoading = ref(true);

    withDefaults(defineProps<Props>(), {
        codeId: undefined,
        codeSetName: undefined,
        title: undefined,
        codeTemplateValues: undefined,
        beforeSaveCode: async () => {},
        fieldsToDisable: () => [],
        referableCodesFilters: undefined,
        referableCodesValidators: undefined,
        refCodeChangedHandlers: undefined
    });

    function onCancel() {
        emit('onCancel');
    }

    function onRefresh() {
        emit('onRefresh');
    }

    function checkLoaded() {
        isLoading.value = false;
    }

</script>

<template>
    <modal-base-footer-less
        v-show="!isLoading"
        @onCancel="onCancel">
        <template #modal-header>
            <b>{{ title }}</b>
        </template>
        <template #modal-body>
            <div
                v-if="codeSetName || codeId"
                id="editor">
                <code-edit
                    :quick-commit="true"
                    :code-set-name="codeSetName"
                    :code-id="codeId"
                    :code-template-values="codeTemplateValues"
                    :before-save-code="beforeSaveCode"
                    :fields-to-disable="fieldsToDisable"
                    :referable-codes-filters="referableCodesFilters"
                    :referable-codes-validators="referableCodesValidators"
                    :ref-code-changed-handlers="refCodeChangedHandlers"
                    :library="library"
                    @refresh="onRefresh"
                    @cancel="onCancel"
                    @loaded="checkLoaded" />
            </div>
        </template>
    </modal-base-footer-less>
</template>
<style scoped>

</style>
